export type NavItem = {
  label: string;
  href: string;
};

export const mainNav: NavItem[] = [
  { label: 'Services', href: '/services' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const footerNavGroups: { title: string; links: NavItem[] }[] = [
  {
    title: 'Studio',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Logo design', href: '/services/logo-design' },
      { label: 'Website design', href: '/services/website-design' },
      { label: 'Website development', href: '/services/website-development' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy policy', href: '/privacy-policy' },
      { label: 'Terms of use', href: '/terms-of-use' },
      { label: 'Refund policy', href: '/refund-policy' },
    ],
  },
];
